export default [
  { name: 'background', x: 0, y: 0, width: 72, height: 96 },
  { name: 'pipe', x: 75, y: 4, width: 8, height: 73 },
  { name: 'bird_000', x: 2, y: 75, width: 25, height: 20 },
  { name: 'bird_001', x: 26, y: 74, width: 25, height: 20 },
  { name: 'bird_002', x: 49, y: 74, width: 25, height: 20 },
  { name: 'ground', x: 172, y: 13, width: 16, height: 72 },
];
